import { MouseEvent } from 'react';
import { Box, Grid, Theme } from '@mui/material';
import { IconButton } from '@components/iconButton';
import { LinkMedium } from '@assets/svgs';
import { INLINE_STYLES, iconStyle } from './RichTextEditor.styles';

interface IRichTextControls {
  updateStyle: (style: string) => void;
  updateLink: (e: MouseEvent<HTMLElement>) => void;
  isDisabled?: boolean;
}

export const RichTextControls = ({ updateStyle, updateLink, isDisabled = false }: IRichTextControls) => {
  const onClickButton = (e: MouseEvent<HTMLElement>, style: string) => {
    e.preventDefault();
    updateStyle(style);
  };
  return (
    <Grid
      container
      direction='row'
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {INLINE_STYLES.map((type) => (
        <IconButton
          onMouseDown={(e) => onClickButton(e, type.style)}
          key={type.style}
          disabled={isDisabled}
          sx={iconStyle}
        >
          {type.icon}
        </IconButton>
      ))}
      <Box
        sx={(theme: Theme) => ({
          display: 'inline',
          borderLeft: theme.borders.main,
          height: '24px',
        })}
      />
      <IconButton onMouseDown={updateLink} disabled={isDisabled} sx={iconStyle}>
        <LinkMedium />
      </IconButton>
    </Grid>
  );
};
